import { styled } from "styled-components";

export const Divider = styled("div")(({ theme }) => ({
  width: "100%",
  height: "2px",
  backgroundColor: theme.colors.text.softGray,
}));
